@if (site != null) {
  <div>
    <mat-card>
      <mat-card-header>
        <mat-card-title>Mist Site {{site.name}}</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content>
        <mat-slide-toggle>Guest WiFi</mat-slide-toggle>
      </mat-card-content>
    </mat-card>
  </div>
}